import React, { useEffect, useRef, useState } from 'react';
import { LOCAL_FONT_CATALOG } from './pdfFontCompat';
import './FontPicker.css';
import './FontPicker.theme.css';

export default function FontPicker({ selectedFont, onSelect, style }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener('pointerdown', handlePointerDown);
    return () => document.removeEventListener('pointerdown', handlePointerDown);
  }, []);

  const active = selectedFont || null;
  const label = active?.label || 'Police';

  const choose = (font) => {
    // The preview/editor resolves embedded PDF fonts when the field renders.
    // Loading a raw subset here would make the browser fall back before that
    // template-aware resolution can happen.
    onSelect?.(font);
    setOpen(false);
  };

  return (
    <div ref={rootRef} className="pdf-font-picker" data-font-picker="true" style={style}>
      <button
        type="button"
        className={`pdf-font-picker-button${open ? ' is-open' : ''}`}
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => setOpen((value) => !value)}
        title="Choisir la police d’écriture"
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <span className="pdf-font-picker-aa">Aa</span>
        <span className="pdf-font-picker-label">{label}</span>
      </button>

      {open && (
        <div className="pdf-font-picker-menu" role="menu">
          <button
            type="button"
            className={`pdf-font-picker-option${active == null ? ' is-active' : ''}`}
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => { onSelect?.(null); setOpen(false); }}
          >
            <span>Police originale</span>
          </button>
          {LOCAL_FONT_CATALOG.map((font) => (
            <button
              key={font.id}
              type="button"
              className={`pdf-font-picker-option${active?.id === font.id ? ' is-active' : ''}`}
              style={{ fontFamily: font.previewFamily || font.cssFamily }}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => choose(font)}
              role="menuitem"
            >
              <span>{font.label}</span>
              <span className="pdf-font-picker-preview">Aa</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
